import { render, staticRenderFns } from "./HomeReminder.vue?vue&type=template&id=68382cbe&scoped=true"
import script from "./HomeReminder.vue?vue&type=script&lang=js"
export * from "./HomeReminder.vue?vue&type=script&lang=js"
import style0 from "./HomeReminder.vue?vue&type=style&index=0&id=68382cbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68382cbe",
  null
  
)

export default component.exports